import {pushNotification} from '@malt/joy-entrypoint/src/js/notification';

export function sendRenewal(signinRenewEmailMandatoryLabel, renewSendSuccess, renewSendFailed, $targetField) {
    const $emailField = $targetField !== undefined ? $targetField : $('#j_username');
    if (!$emailField.val()) {
        pushNotification(signinRenewEmailMandatoryLabel, {level: 'warning'});
    } else {
        const request = $.ajax({
            url: '/api/pwdrenewal',
            type: 'POST',
            data: JSON.stringify({
                email: $emailField.val(),
            }),
            contentType: 'application/json',
        });
        request.done(() => {
            $('.notif__wrapper').hide();
            pushNotification(renewSendSuccess);
        });
        request.fail(() => {
            $('.notif__wrapper').hide();
            pushNotification(renewSendFailed, {level: 'error'});
        });
    }
}
